import { Card } from "@/components/ui/card";
import { fmtMXN, fmtPct, type Tabla } from "@/lib/amortizacion";

export function ResumenCards({
  tabla,
  extra,
}: {
  tabla: Tabla;
  extra?: { label: string; value: string };
}) {
  const items = [
    { label: "Monto otorgado", value: fmtMXN(tabla.monto), tone: "navy" },
    { label: "Total de intereses", value: fmtMXN(tabla.totalIntereses), tone: "chart-3" },
    { label: "Total pagado por el cliente", value: fmtMXN(tabla.totalPagado), tone: "navy" },
    { label: "Costo del crédito", value: fmtPct(tabla.costoPct), tone: "emerald" },
    ...(extra ? [{ label: extra.label, value: extra.value, tone: "emerald" }] : []),
  ];
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
      {items.map((it) => (
        <Card key={it.label} className="print-block border-navy/15 p-4 shadow-sm">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            {it.label}
          </p>
          <p
            className={`mt-2 num text-xl font-semibold ${it.tone === "emerald" ? "text-emerald" : it.tone === "chart-3" ? "text-chart-3" : "text-navy"}`}
          >
            {it.value}
          </p>
        </Card>
      ))}
    </div>
  );
}
